const ALL_FEATURES = [
  "forum",
  "chat",
  "apply",
  "pairing",
  "events",
  "perks",
  "jobs",
  "newsletter",
  "paid",
  "courses",
  "tools",
  "token",
]

const RARE_FEATURE_THRESHOLD = 0.15

/** Short copy for aggregate stats and topic research pages. */
const FEATURE_DESCRIPTIONS = {
  forum: "Threaded discussions and forum-style posts",
  chat: "Real-time chat for members",
  apply: "Requires an application or approval to join",
  pairing: "Matches members for intros, accountability, or networking",
  events: "Hosts online or offline events",
  perks: "Offers member perks, discounts, or benefits",
  jobs: "Includes jobs, hiring, or opportunity posts",
  newsletter: "Publishes a member or topic newsletter",
  paid: "Has a paid membership or premium tier",
  courses: "Includes courses, workshops, or learning programs",
  tools: "Provides tools, templates, or resources",
  token: "Uses tokens, NFTs, or web3 access",
}

/** Copy for rare-feature badges on community pages. */
const FEATURE_OFFER_COPY = {
  forum: "a forum",
  chat: "live chat",
  apply: "an application process",
  pairing: "member pairing",
  events: "events",
  perks: "member perks",
  jobs: "a job board",
  newsletter: "a newsletter",
  paid: "paid membership tiers",
  courses: "courses",
  tools: "tools and resources",
  token: "a crypto token",
}

/** Has / missing copy for community detail feature list. */
const FEATURE_COMMUNITY_COPY = {
  forum: {
    has: "This community has a forum",
    missing: "This community does not have a forum",
  },
  chat: {
    has: "This community has a realtime chat",
    missing: "This community does not have a realtime chat",
  },
  apply: {
    has: "This community requires an application to join",
    missing: "This community does not require an application to join",
  },
  pairing: {
    has: "This community sets up 1:1 pairing between its members",
    missing: "This community does not set up 1:1 pairing between its members",
  },
  perks: {
    has:
      "This community has discounts and perks for its members (potentially for a cost)",
    missing: "This community does not have discounts and perks for its members",
  },
  events: {
    has: "This community hosts offline events and meetups",
    missing: "This community does not host offline events and meetups",
  },
  newsletter: {
    has: "This community has an email newsletter of related content",
    missing: "This community does not have an associated newsletter",
  },
  jobs: {
    has:
      "This community has a job board or provides career networking opportunities",
    missing: "This community does not have an associated job board",
  },
  paid: {
    has: "This community has a paid membership level",
    missing: "This community does not require a paid membership",
  },
  courses: {
    has: "This community offers educational courses",
    missing: "This community does not offer educational courses",
  },
  tools: {
    has: "This community aggregates tools & resources",
    missing: "This community does not aggregate tools & resources",
  },
  token: {
    has: "This community has a crypto token",
    missing: "This community does not have a crypto token",
  },
}

function getFeatureDescription(slug, fallbackName) {
  return (
    FEATURE_DESCRIPTIONS[slug] ||
    `${fallbackName || slug} availability across listings`
  )
}

function getFeatureCommunityText(slug, has) {
  const copy = FEATURE_COMMUNITY_COPY[slug]
  if (!copy) return ""
  return has ? copy.has : copy.missing
}

module.exports = {
  ALL_FEATURES,
  RARE_FEATURE_THRESHOLD,
  FEATURE_DESCRIPTIONS,
  FEATURE_OFFER_COPY,
  FEATURE_COMMUNITY_COPY,
  getFeatureDescription,
  getFeatureCommunityText,
}
